import { Modal } from 'antd'
import { ITransaction } from 'api'
import { Formik } from 'formik'
import { FC } from 'react'
import TransactionForm from './form'
import { useTransactionModal } from './hooks'
import Skeleton from './skeleton'

export interface ITransactionModal extends Pick<ITransaction, 'id'> {}

const TransactionModal: FC<ITransactionModal> = ({ id }) => {
	const data = useTransactionModal(id)

	const { t, hideModal, initialValues, schema, onSubmit, isTransactionFetched, isTransactionLoading } = data

	return (
		<Modal
			title={id ? t('actions.editTransaction') : t('actions.addTransaction')}
			width={660}
			open
			onCancel={hideModal}
			footer={null}
		>
			<Formik initialValues={initialValues} validationSchema={schema} enableReinitialize onSubmit={onSubmit}>
				{isTransactionLoading && !isTransactionFetched ? <Skeleton /> : <TransactionForm {...data} />}
			</Formik>
		</Modal>
	)
}

export default TransactionModal
